import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const state = {
	socket: false,
	online: false,
	pool: [],
	live: {}
};

export default {
	namespaced: true,
    state,
    mutations,
    actions,
    getters
};



// WEBPACK FOOTER //
// ./src/store/socket/index.js